import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";

import { useRouter } from "next/router";

// ====================================================================================
const RepickDialog = ({
  showRepick,
  slot,
  title,
  onPick,
}: {
  showRepick: boolean;
  slot: string | Date;
  title?: string;
  onPick?: () => void;
}) => {
  const { push } = useRouter();

  if (!slot) return null;
  return (
    <Dialog
      open={showRepick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ color: "text.primary" }}>
        {title ?? "Slot no longer available"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`Unable to book the slot ${slot}. Please choose a different slot.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={onPick ? onPick : () => push("/repick")}
          autoFocus
        >
          Pick another slot
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RepickDialog;
